import { Injectable, Component } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { SessionService } from './services/session.service';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/take';

@Injectable()
export class AuthorizationGuard implements CanActivate {

    constructor(private router: Router, private sessionService: SessionService) { }

    public canActivate() {
        if (this.sessionService.isAuthenticated) {
            return true;
        }
        if (this.sessionService.pendingChangePass) {
            this.router.navigate(['home/changePassword']);
            return true;
        }

        if (localStorage.getItem('Oficina.WebApi.Angular4.Token')) {
            return this.sessionService.sessionRestored.take(1).map(authenticated => {
                if (!authenticated) {
                    this.router.navigate(['public/login']);
                }
                return authenticated;
            });
        }

        this.router.navigate(['public/login']);
        return false;
    }

}



// WEBPACK FOOTER //
// C:/Users/jboix/source/repos/classic/OficinaAngular/src/app/authorization-guard.ts